import { call, put, takeEvery, takeLatest, take, cancel, fork, race } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';
import {
  UPDATE_REFERRAL_SOURCE_SUCCESS,
  ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS,
  REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS,
  CREATE_REFERRAL_SOURCE_CONTACT_SUCCESS,
  UPDATE_REFERRAL_SOURCE_CONTACT_SUCCESS,
  DELETE_REFERRAL_SOURCE_CONTACT_SUCCESS,
} from 'redux/modules/referralSources';
import { UPDATE_SALES_REPRESENTATIVE_SUCCESS } from 'redux/modules/salesRepresentatives';
import {
  UPDATE_PRESCRIBER_SUCCESS,
  ADD_PRESCRIBER_RESOURCE_SUCCESS,
  REMOVE_PRESCRIBER_RESOURCE_SUCCESS,
} from 'redux/modules/prescribers';
import { FETCH_PATIENT_MESSAGES_SUCCESS, RECIEVE_PATIENT_MESSAGE } from 'redux/modules/patientsMessages';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

// Actions
export const FETCH_PATIENTS = 'FETCH_PATIENTS';
export const FETCH_PATIENTS_SUCCESS = 'FETCH_PATIENTS_SUCCESS';
export const FETCH_PATIENTS_FAIL = 'FETCH_PATIENTS_FAIL';
export const CANCEL_FETCH_PATIENTS = 'CANCEL_FETCH_PATIENTS';
export const CLEAR_PATIENTS = 'CLEAR_PATIENTS';
export const FETCH_PATIENT = 'FETCH_PATIENT';
export const FETCH_PATIENT_SUCCESS = 'FETCH_PATIENT_SUCCESS';
export const FETCH_PATIENT_FAIL = 'FETCH_PATIENT_FAIL';
export const CREATE_PATIENT = 'CREATE_PATIENT';
export const CREATE_PATIENT_SUCCESS = 'CREATE_PATIENT_SUCCESS';
export const CREATE_PATIENT_FAIL = 'CREATE_PATIENT_FAIL';
export const UPDATE_PATIENT = 'UPDATE_PATIENT';
export const UPDATE_PATIENT_SUCCESS = 'UPDATE_PATIENT_SUCCESS';
export const UPDATE_PATIENT_FAIL = 'UPDATE_PATIENT_FAIL';
export const DELETE_PATIENT = 'DELETE_PATIENT';
export const DELETE_PATIENT_SUCCESS = 'DELETE_PATIENT_SUCCESS';
export const DELETE_PATIENT_FAIL = 'DELETE_PATIENT_FAIL';
export const ADD_PATIENT_RESOURCE = 'ADD_PATIENT_RESOURCE';
export const ADD_PATIENT_RESOURCE_SUCCESS = 'ADD_PATIENT_RESOURCE_SUCCESS';
export const ADD_PATIENT_RESOURCE_FAIL = 'ADD_PATIENT_RESOURCE_FAIL';
export const REMOVE_PATIENT_RESOURCE = 'REMOVE_PATIENT_RESOURCE';
export const REMOVE_PATIENT_RESOURCE_SUCCESS = 'REMOVE_PATIENT_RESOURCE_SUCCESS';
export const REMOVE_PATIENT_RESOURCE_FAIL = 'REMOVE_PATIENT_RESOURCE_FAIL';
export const CHANGE_PATIENT_RESOURCE = 'CHANGE_PATIENT_RESOURCE';
export const CHANGE_PATIENT_RESOURCE_SUCCESS = 'CHANGE_PATIENT_RESOURCE_SUCCESS';
export const CHANGE_PATIENT_RESOURCE_FAIL = 'CHANGE_PATIENT_RESOURCE_FAIL';

// Reducer
export default function patientsReducer(state = { data: [], count: 0, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_PATIENTS:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_PATIENTS_SUCCESS:
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_PATIENTS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_PATIENTS:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case CANCEL_FETCH_PATIENTS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_PATIENT:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_PATIENT_SUCCESS:
    case CREATE_PATIENT_SUCCESS: {
      let isPresent = false;
      let newCount = state.count;
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        isPresent = true;
        return {
          ...dataItem,
          ...payload,
        };
      });
      if (!isPresent) {
        newCount += 1;
        newData.push(payload);
      }
      return {
        ...state,
        count: newCount,
        data: newData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_PATIENT_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case UPDATE_PATIENT_SUCCESS:
    case ADD_PATIENT_RESOURCE_SUCCESS:
    case REMOVE_PATIENT_RESOURCE_SUCCESS:
    case CHANGE_PATIENT_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case RECIEVE_PATIENT_MESSAGE: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Patient ID']) {
          return dataItem;
        }
        return {
          ...dataItem,
          'Unread SMS': dataItem['Unread SMS'] + 1,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_REFERRAL_SOURCE_SUCCESS:
    case ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS:
    case REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        const newReferralSource = dataItem['Referral Source'].map((referralSourceItem) => {
          if (referralSourceItem.ID !== payload.ID) {
            return referralSourceItem;
          }
          return {
            ...referralSourceItem,
            ...payload,
          };
        });
        const newSales = dataItem['Sales Representative'].map((salesItem) => {
          const salesIndex = payload['Sales Representative'].findIndex(payloadSalesItem => salesItem.ID === payloadSalesItem.ID);
          const referralSourceIndex = salesItem['Referral Source'].findIndex(referralSourceItem => referralSourceItem.ID === payload.ID);
          if (salesIndex === -1 && referralSourceIndex !== -1) {
            return {
              ...salesItem,
              'Referral Source': [
                ...salesItem['Referral Source'].slice(0, referralSourceIndex),
                ...salesItem['Referral Source'].slice(referralSourceIndex + 1),
              ],
            };
          } else if (salesIndex !== -1 && referralSourceIndex === -1) {
            return {
              ...salesItem,
              'Referral Source': [
                ...salesItem['Referral Source'],
                payload,
              ],
            };
          } else {
            return salesItem;
          }
        });

        return {
          ...dataItem,
          'Referral Source': newReferralSource,
          'Sales Representative': newSales,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case CREATE_REFERRAL_SOURCE_CONTACT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Referral Source']) {
          return dataItem;
        }

        const newReferralSource = dataItem['Referral Source'].map((referralSourceItem) => {
          const createdReferralSourceContact = payload.data.filter(contactItem =>
            contactItem['Referral Source ID'] === referralSourceItem.ID);
          if (createdReferralSourceContact.length > 0) {
            return {
              ...referralSourceItem,
              'Referral Source Contact': [
                ...referralSourceItem['Referral Source Contact'],
                ...createdReferralSourceContact,
              ],
            };
          }
          return referralSourceItem;
        });

        return {
          ...dataItem,
          'Referral Source': newReferralSource,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_REFERRAL_SOURCE_CONTACT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Referral Source']) {
          return dataItem;
        }

        const newReferralSource = dataItem['Referral Source'].map((referralSourceItem) => {
          const newReferralSourceContact = referralSourceItem['Referral Source Contact'].map((contactItem) => {
            const newContact = payload.data.find(updatedContactItem =>
              updatedContactItem.ID === contactItem.ID);
            return newContact || contactItem;
          });
          return {
            ...referralSourceItem,
            'Referral Source Contact': newReferralSourceContact,
          };
        });

        return {
          ...dataItem,
          'Referral Source': newReferralSource,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_REFERRAL_SOURCE_CONTACT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Referral Source']) {
          return dataItem;
        }

        const newReferralSource = dataItem['Referral Source'].map((referralSourceItem) => {
          const newReferralSourceContact = referralSourceItem['Referral Source Contact'].filter(contactItem =>
            !payload.data.find(deletedContactItem =>
              deletedContactItem.ID === contactItem.ID));
          return {
            ...referralSourceItem,
            'Referral Source Contact': newReferralSourceContact,
          };
        });

        return {
          ...dataItem,
          'Referral Source': newReferralSource,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_SALES_REPRESENTATIVE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Sales Representative']) {
          return dataItem;
        }

        const newSalesRepresentative = dataItem['Sales Representative'].map((salesRepresentativeItem) => {
          if (salesRepresentativeItem.ID !== payload.ID) {
            return salesRepresentativeItem;
          }

          return {
            ...salesRepresentativeItem,
            ...payload,
          };
        });

        return {
          ...dataItem,
          'Sales Representative': newSalesRepresentative,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_PRESCRIBER_SUCCESS:
    case ADD_PRESCRIBER_RESOURCE_SUCCESS:
    case REMOVE_PRESCRIBER_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        const newPrescriber = dataItem.Prescriber.map((prescriberItem) => {
          if (prescriberItem.ID !== payload.ID) {
            return prescriberItem;
          }

          return {
            ...prescriberItem,
            ...payload,
          };
        });
        const newReferralSource = dataItem['Referral Source'].map((referralSourceItem) => {
          const referralSourceIndex = payload['Referral Source'].findIndex(payloadReferralSourceItem => referralSourceItem.ID === payloadReferralSourceItem.ID);
          const prescriberIndex = referralSourceItem.Prescriber.findIndex(prescriberItem => prescriberItem.ID === payload.ID);
          if (referralSourceIndex === -1 && prescriberIndex !== -1) {
            return {
              ...referralSourceItem,
              Prescriber: [
                ...referralSourceItem.Prescriber.slice(0, prescriberIndex),
                ...referralSourceItem.Prescriber.slice(prescriberIndex + 1),
              ],
            };
          } else if (referralSourceIndex !== -1 && prescriberIndex === -1) {
            return {
              ...referralSourceItem,
              Prescriber: [
                ...referralSourceItem.Prescriber,
                payload,
              ],
            };
          } else {
            return referralSourceItem;
          }
        });

        return {
          ...dataItem,
          Prescriber: newPrescriber,
          'Referral Source': newReferralSource,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case FETCH_PATIENT_MESSAGES_SUCCESS: {
      const newData = state.data.map((dataItem) => ({
        ...dataItem,
        'Unread SMS': 0,
      }));
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PATIENT_SUCCESS: {
      const index = state.data
        .findIndex(item => item['Record Number'] === payload['Record Number']);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchPatients(payload) {
  return { type: FETCH_PATIENTS, payload };
}

export function fetchPatientsSuccess(payload) {
  return { type: FETCH_PATIENTS_SUCCESS, payload };
}

export function fetchPatientsFail(payload) {
  return { type: FETCH_PATIENTS_FAIL, payload };
}

export function cancelFetchPatients(payload) {
  return { type: CANCEL_FETCH_PATIENTS, payload };
}

export function clearPatients(payload) {
  return { type: CLEAR_PATIENTS, payload };
}

export function fetchPatient(payload) {
  return { type: FETCH_PATIENT, payload };
}

export function fetchPatientSuccess(payload) {
  return { type: FETCH_PATIENT_SUCCESS, payload };
}

export function fetchPatientFail(payload) {
  return { type: FETCH_PATIENT_FAIL, payload };
}

export function createPatient(payload) {
  return { type: CREATE_PATIENT, payload };
}

export function createPatientSuccess(payload) {
  return { type: CREATE_PATIENT_SUCCESS, payload };
}

export function createPatientFail(payload) {
  return { type: CREATE_PATIENT_FAIL, payload };
}

export function updatePatient(payload) {
  return { type: UPDATE_PATIENT, payload };
}

export function updatePatientSuccess(payload) {
  return { type: UPDATE_PATIENT_SUCCESS, payload };
}

export function updatePatientFail(payload) {
  return { type: UPDATE_PATIENT_FAIL, payload };
}

export function deletePatient(payload) {
  return { type: DELETE_PATIENT, payload };
}

export function deletePatientSuccess(payload) {
  return { type: DELETE_PATIENT_SUCCESS, payload };
}

export function deletePatientFail(payload) {
  return { type: DELETE_PATIENT_FAIL, payload };
}

export function addPatientResource(payload) {
  return { type: ADD_PATIENT_RESOURCE, payload };
}

export function addPatientResourceSuccess(payload) {
  return { type: ADD_PATIENT_RESOURCE_SUCCESS, payload };
}

export function addPatientResourceFail(payload) {
  return { type: ADD_PATIENT_RESOURCE_FAIL, payload };
}

export function removePatientResource(payload) {
  return { type: REMOVE_PATIENT_RESOURCE, payload };
}

export function removePatientResourceSuccess(payload) {
  return { type: REMOVE_PATIENT_RESOURCE_SUCCESS, payload };
}

export function removePatientResourceFail(payload) {
  return { type: REMOVE_PATIENT_RESOURCE_FAIL, payload };
}

export function changePatientResource(payload) {
  return { type: CHANGE_PATIENT_RESOURCE, payload };
}

export function changePatientResourceSuccess(payload) {
  return { type: CHANGE_PATIENT_RESOURCE_SUCCESS, payload };
}

export function changePatientResourceFail(payload) {
  return { type: CHANGE_PATIENT_RESOURCE_FAIL, payload };
}

// Requests

let abort;

export function requestFetchPatients({ limit, offset }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi(`patient/main/?limit=${limit}&offset=${offset}`);
  abort = request.abort;
  return request.res;
}

export function requestSearchPatients({ limit, offset, filters = [], sortBy = [] }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('patient/main/search/', 'POST', {
    ...filters ? { filters } : {},
    sort_by: [
      ...sortBy,
      {
        name: 'Record Number',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestFetchPatient(payload) {
  return callApi(`patient/main/?record_number=${payload}`);
}

export function requestCreatePatient(payload) {
  return callApi('patient/main/', 'POST', payload);
}

export function requestDeletePatient(payload) {
  return callApi(`patient/main/?id=${payload}`, 'DELETE');
}

export function requestUpdatePatient(payload) {
  return callApi('patient/main/', 'PATCH', payload);
}

export function requestAddPatientResource(payload) {
  return callApi('patient/main/change_resource/add/', 'POST', payload);
}

export function requestRemovePatientResource(payload) {
  return callApi('patient/main/change_resource/remove/', 'POST', payload);
}

export function requestChangePatientResource(payload) {
  return callApi('patient/main/change_resource/patch/', 'POST', payload);
}

// Sagas
let canceledFetchPatients = false;
function* fetchPatientsSaga(action) {
  const { triggerLoading, filters, sortBy, push, resolve, reject } = action.payload;
  canceledFetchPatients = false;
  try {
    const res = filters || sortBy
        ? yield call(requestSearchPatients, action.payload)
        : yield call(requestFetchPatients, action.payload);
    if (!canceledFetchPatients) {
      if (res.count === 0) {
        yield put(fetchPatientsSuccess({
          data: res.data,
          count: res.count,
          triggerLoading,
        }));
      } else if (push) {
        yield put(fetchPatientsSuccess({
          push: true,
          data: res.data,
          count: res.count,
          triggerLoading,
        }));
      } else {
        yield put(fetchPatientsSuccess({
          data: res.data,
          count: res.count,
          triggerLoading,
        }));
      }
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
      if (resolve) {
        resolve(res.data);
      }
    }
  } catch (err) {
    yield put(fetchPatientsFail({
      ...err.data,
      triggerLoading,
    }));
    if (reject) {
      reject(err.data);
    }
  }
}

function* cancelFetchPatientsSaga(action) {
  canceledFetchPatients = true;
}

function* fetchPatientSaga(action) {
  const { triggerLoading, recoverOrderValues } = action.payload;
  try {
    const res = yield call(requestFetchPatient, action.payload['Record Number']);
    if (res.data['Record Number']) {
      yield put(fetchPatientSuccess({
        ...res.data,
        triggerLoading,
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      yield put(fetchPatientFail());
    }
  } catch (err) {
    if (err.data.error === 'Access Error' && recoverOrderValues) {
      yield put(saveRecoverOrder(recoverOrderValues));
    }
    yield put(fetchPatientFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createPatientSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreatePatient, values);
    yield put(createPatientSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New patient chart successfully created',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createPatientFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updatePatientSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdatePatient, values);
    yield put(updatePatientSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Patient chart successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updatePatientFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deletePatientSaga(action) {
  try {
    const res = yield call(requestDeletePatient, action.payload['Record Number']);
    yield put(deletePatientSuccess(action.payload));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Patient chart successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deletePatientFail(err.data));
  }
}

function* addPatientResourceSaga(action) {
  const {
    resolve,
    reject,
    ...otherValues
  } = action.payload;
  try {
    const res = yield call(requestAddPatientResource, otherValues);
    yield put(addPatientResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(addPatientResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* removePatientResourceSaga(action) {
  try {
    const res = yield call(requestRemovePatientResource, action.payload);
    yield put(removePatientResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(removePatientResourceFail(err.data));
  }
}

function* changePatientResourceSaga(action) {
  const {
    resolve,
    reject,
    ...otherValues
  } = action.payload;
  try {
    const res = yield call(requestChangePatientResource, otherValues);
    yield put(changePatientResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(changePatientResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* patientsSaga() {
  yield takeLatest(FETCH_PATIENTS, fetchPatientsSaga);
  yield takeEvery(CANCEL_FETCH_PATIENTS, cancelFetchPatientsSaga);
  yield takeEvery(FETCH_PATIENT, fetchPatientSaga);
  yield takeEvery(CREATE_PATIENT, createPatientSaga);
  yield takeEvery(UPDATE_PATIENT, updatePatientSaga);
  yield takeEvery(DELETE_PATIENT, deletePatientSaga);
  yield takeEvery(ADD_PATIENT_RESOURCE, addPatientResourceSaga);
  yield takeEvery(REMOVE_PATIENT_RESOURCE, removePatientResourceSaga);
  yield takeEvery(CHANGE_PATIENT_RESOURCE, changePatientResourceSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patients.js